import { render } from "./CoachDetail.vue?vue&type=template&id=1e671a89"
import script from "./CoachDetail.vue?vue&type=script&lang=js"
export * from "./CoachDetail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/michaelp/Library/CloudStorage/OneDrive-個人/Visual Studio/Vue Complete/auth-09-adding-auto-login/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__